import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import ReportCard from './ReportCard'
import ReportFolderCard from './ReportFolderCard'
export default function ReportList({ list, handleFavrtReport, handleDeleteReport,handleChangeOwnerPopup, handleAddFolderPopup, handleMoveReportPopup, handleEditReport,handleRemoveReportFrmFolder,handleViewReport,pageNo, ...other }) {
  return (
    <Grid container spacing={3} {...other}>
      {list.filter(itm => itm.isFolder).map((item, i) => (
        <Grid key={i} item xs={12} sm={6} md={4}>
          <ReportFolderCard
            folder={item}
            handleDeleteReport={handleDeleteReport}
            handleFavrtReport={handleFavrtReport}
            handleAddFolderPopup={handleAddFolderPopup}
            pageNo={pageNo}
          />
        </Grid>
      ))}
      <Box width="100%" />
      {list.filter(itm => !itm.isFolder).map((item, i) => (
        <Grid key={i} item xs={12} sm={6} md={6}>
          <ReportCard
            report={item}
            handleDeleteReport={handleDeleteReport}
            handleFavrtReport={handleFavrtReport}
            handleMoveReportPopup={handleMoveReportPopup}
            handleEditReport={handleEditReport}
            handleRemoveReportFrmFolder={handleRemoveReportFrmFolder}
            handleViewReport={handleViewReport}
            handleChangeOwnerPopup={handleChangeOwnerPopup}
            pageNo={pageNo}
          />
        </Grid>
      ))}
    </Grid>
  )
}

ReportList.propTypes = {
  list: PropTypes.array.isRequired,
}
